export const baseURL = process.env.REACT_APP_API_URL;
export const socketServer = process.env.REACT_APP_SOCKET;
